import * as React from 'react';

import Image from 'components/atoms/Image';
import { ImageProps } from 'components/atoms/Image';
import Lightbox from 'components/molecules/Lightbox';
import { LightboxProps } from 'components/molecules/Lightbox';
import LinkList from 'components/molecules/LinkList';
import { LinkListEntryType } from 'components/molecules/LinkList';
import Rich from 'components/molecules/Rich';

export type ContentImageProps = {
	modifier?: string;
	image: ImageProps;
	lightbox?: LightboxProps;
	slide?: number[];
	caption?: {
		title?: string;
		text?: string;
		links?: LinkListEntryType[];
	};
};

const ContentImage = ({ modifier, image, lightbox, caption, slide }: ContentImageProps) => {
	return (
		<figure className={`m-content-image${modifier ? ` m-content-image--${modifier}` : ''}`}>
			<div className="m-content-image__wrapper">
				<Image srcset={image.srcset} title={image.title} alt={image.alt} />
				{lightbox && <Lightbox image={lightbox.image} pinterest={lightbox.pinterest} />}
			</div>
			{caption && (
				<figcaption className="m-content-image__caption">
					{slide && slide.length > 0 && (
						<div className="m-content-image__meta">
							{slide[0]} / {slide[1]}
						</div>
					)}
					{caption.title && <h6 className="m-content-image__title">{caption.title}</h6>}
					{caption.text && <Rich contents={caption.text} />}
					{caption.links && caption.links.length > 0 && <LinkList links={caption.links} />}
				</figcaption>
			)}
		</figure>
	);
};

export default ContentImage;
